import DynamicRoute from 'app/constants/Routes/DynamicRoute';
import StaticRoute from 'app/constants/Routes/StaticRoute';
import { IBrandDomain } from 'app/constants/schemas/BrandDomain';
import { getBasePath } from 'app/services/basePath';
import { EntityFields } from 'app/types/entity';

export const resolveStaticRouteInBrandDomain = (domain: EntityFields<IBrandDomain>, route: StaticRoute) => {
  const localPathname = route.getPathname();
  const basePathname = localPathname.substring(getBasePath().length);
  return `${getBrandDomainLocation(domain)}${basePathname}`;
};

export const resolveDynamicRouteInBrandDomain = <Params extends Record<string, unknown>>(
  domain: EntityFields<IBrandDomain>,
  route: DynamicRoute<Params>,
  params: Params,
) => {
  const localPathname = route.getPathname(params);
  const basePathname = localPathname.substring(getBasePath().length);
  return `${getBrandDomainLocation(domain)}${basePathname}`;
};

export const getBrandDomainLocation = (
  domain: EntityFields<IBrandDomain>,
): string => domain.envUri;
